/**
 * Created by anatoly on 27.07.2025
 */

const SpaceRaceMerge2Adapter = {
    SubscribeToEvents: function () {
        const update = (mission) => {
            if (!Merge2.current) {
                return;
            }
            if (mission.getType() === Mission.TYPE_SPACE_RACE) {
                cleverapps.eventBus.trigger("ordersDataSourceUpdateAll");
                
                Merge2.current.customers.forceRewardsUpdate();
            }
        };

        cleverapps.missionManager.on("add", update);
        cleverapps.missionManager.on("complete", update);
        cleverapps.missionManager.on("startStage", update);
        cleverapps.missionManager.on("stopStage", update);

        cleverapps.eventBus.on("complete_order", () => {
            cleverapps.personalBest.addPoint("spacerace", 1);
        });

        cleverapps.missionManager.on("wantToShowNewState", (mission) => {
            if (mission.type !== Mission.TYPE_SPACE_RACE || cleverapps.focusManager.isFocused()) {
                return;
            }

            cleverapps.focusManager.display({
                focus: "missionWindow",
                action: function (f) {
                    const WindowClass = mission.getViewClass();
                    new WindowClass(mission);
                    cleverapps.focusManager.onceNoWindowsListener = f;
                }
            });
        });
    }
};

cleverapps.whenAllInitialized(() => SpaceRaceMerge2Adapter.SubscribeToEvents());